var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "tab-header-item",
      class: { active: _vm.active },
      style: _vm.tabStyle,
      attrs: { role: "presentation", rel: _vm.name }
    },
    [
      _c(
        "button",
        {
          staticClass: "caption",
          attrs: {
            id: "trigger-" + _vm.name,
            role: "tab",
            "aria-controls": _vm.name,
            "aria-selected": _vm.active,
            tabindex: _vm.index
          },
          on: { click: _vm.clickHandler }
        },
        [
          _c(
            "span",
            {
              staticClass: "icon",
              style: _vm.iconStyle,
              attrs: { "aria-hidden": "true" }
            },
            [_vm._t("icon")],
            2
          ),
          _vm._v(" "),
          _c("span", { staticClass: "title" }, [_vm._t("title")], 2),
          _vm._v(" "),
          _vm.active
            ? _c("icon", {
                staticClass: "close",
                attrs: {
                  type: "close",
                  color: _vm.iconColor(true),
                  "aria-hidden": "true"
                }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }